var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStudentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 7C6.75736 7 5.75 5.99264 5.75 4.75C5.75 3.50736 6.75736 2.5 8 2.5C9.24264 2.5 10.25 3.50736 10.25 4.75C10.25 5.99264 9.24264 7 8 7ZM8 8.5C5.92893 8.5 4.25 6.82107 4.25 4.75C4.25 2.67893 5.92893 1 8 1C10.0711 1 11.75 2.67893 11.75 4.75C11.75 6.82107 10.0711 8.5 8 8.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.7811 11.0495C3.70909 9.84619 5.33354 9 8 9C10.6665 9 12.2909 9.84619 13.2189 11.0495C14.1185 12.216 14.25 13.5764 14.25 14.39C14.25 14.8042 13.9142 15.14 13.5 15.14H2.5C2.08579 15.14 1.75 14.8042 1.75 14.39C1.75 13.5764 1.88149 12.216 2.7811 11.0495ZM3.30142 13.64H12.6986C12.6199 13.0918 12.434 12.4879 12.0311 11.9655C11.4591 11.2238 10.3335 10.5 8 10.5C5.66646 10.5 4.54091 11.2238 3.9689 11.9655C3.56604 12.4879 3.38014 13.0918 3.30142 13.64Z",
  fill: "currentColor"
})));
export default SvgStudentIcon;